<template>
  <div class="HanYuan">
    <!--春季：1-3月-->
    <div class="spring" v-if="nowMoth >= 3 && nowMoth <= 5">
      <div class="banner">
        <img width="100%" src="../../../assets/img/HanYuan/HanYuan_Banner_spring.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/HanYuan/HanYuan_huajiao.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/HanYuan/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              汉源花椒历史悠久，唐代列为贡品，故名“贡椒”。以其色泽丹红，粒大油重，芳香浓郁、醇麻爽口，畅销省内外，1984年荣获省优质产品称号，深受消费者欢迎...
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/HanYuan/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')"
        color="#384890" borderBottomColor="#384890" boxBorderColor="#9BA8E4" btnBJcolor="#94BCE0" hoverBJcolor="#2D7FC8">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890" borderBottomColor="#384890"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890"
        borderBottomColor="#384890" boxBorderColor="#9BA8E4"></ztxzList>
    </div>
    <!-- 夏季：4-6月 -->
    <div class="summer" v-else-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/HanYuan/HanYuan_Banner_summer.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/HanYuan/HanYuan_huajiao.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/HanYuan/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              汉源花椒历史悠久，唐代列为贡品，故名“贡椒”。以其色泽丹红，粒大油重，芳香浓郁、醇麻爽口，畅销省内外，1984年荣获省优质产品称号，深受消费者欢迎...
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/HanYuan/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')"
        color="#384890" borderBottomColor="#384890" boxBorderColor="#9BA8E4" btnBJcolor="#94BCE0" hoverBJcolor="#2D7FC8">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890" borderBottomColor="#384890"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890"
        borderBottomColor="#384890" boxBorderColor="#9BA8E4"></ztxzList>
    </div>
    <!-- 秋季：7-9月 -->
    <div class="autumn" v-else-if="nowMoth >= 9 && nowMoth <= 11">
      <div class="banner">
        <img width="100%" src="../../../assets/img/HanYuan/HanYuan_Banner_autumn.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/HanYuan/HanYuan_huajiao.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/HanYuan/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              汉源花椒历史悠久，唐代列为贡品，故名“贡椒”。以其色泽丹红，粒大油重，芳香浓郁、醇麻爽口，畅销省内外，1984年荣获省优质产品称号，深受消费者欢迎...
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/HanYuan/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')"
        color="#384890" borderBottomColor="#384890" boxBorderColor="#9BA8E4" btnBJcolor="#94BCE0" hoverBJcolor="#2D7FC8">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890" borderBottomColor="#384890"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890"
        borderBottomColor="#384890" boxBorderColor="#9BA8E4"></ztxzList>
    </div>
    <!-- 冬季：10-12月 -->
    <div class="winter" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/HanYuan/HanYuan_Banner_winter.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/HanYuan/HanYuan_huajiao.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/HanYuan/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              汉源花椒历史悠久，唐代列为贡品，故名“贡椒”。以其色泽丹红，粒大油重，芳香浓郁、醇麻爽口，畅销省内外，1984年荣获省优质产品称号，深受消费者欢迎...
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/HanYuan/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')"
        color="#384890" borderBottomColor="#384890" boxBorderColor="#9BA8E4" btnBJcolor="#94BCE0" hoverBJcolor="#2D7FC8">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890" borderBottomColor="#384890"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/HanYuan/square.png')" color="#384890"
        borderBottomColor="#384890" boxBorderColor="#9BA8E4"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery,getVillages} from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'HanYuan',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: null,  //当前区县点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'县本级'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   this.getData()
  //   this.GetVillages()
  //   setTimeout(() => {
  //     this.getMatterList()
  //   }, 1000);
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取乡镇列表
  //   GetVillages() {
  //     getVillages().then(res => {
  //       // console.log(res, '乡镇列表')
  //       if (res.status == 200) {
  //         if (res.data.data && res.data.data.length > 0) {
  //           let arrList = res.data.data;
  //           arrList.unshift({ type: null, mapId: "fa08802c1d4d11eda7660242ac120002", name: "县本级" });
  //           for (let index = 0; index < arrList.length; index++) {
  //             switch (arrList[index].name.slice(0, 2)) {
  //               case '县本':
  //                 arrList[index].url = 'HanYuan'
  //                 break;
  //               case '安乐':
  //                 arrList[index].url = 'AnLe'
  //                 break;
  //               case '大树':
  //                 arrList[index].url = 'DaShu'
  //                 break;
  //               case '富林':
  //                 arrList[index].url = 'FuLin'
  //                 break;
  //               case '富泉':
  //                 arrList[index].url = 'FuQuan'
  //                 break;
  //               case '富乡':
  //                 arrList[index].url = 'FuXiang'
  //                 break;
  //               case '富庄':
  //                 arrList[index].url = 'FuZhuang'
  //                 break;
  //               case '河南':
  //                 arrList[index].url = 'HeNan'
  //                 break;
  //               case '皇木':
  //                 arrList[index].url = 'HuangMu'
  //                 break;
  //               case '九襄':
  //                 arrList[index].url = 'JiuXiang'
  //                 break;
  //               case '马烈':
  //                 arrList[index].url = 'MaLie'
  //                 break;
  //               case '坭美':
  //                 arrList[index].url = 'NiMei'
  //                 break;
  //               case '片马':
  //                 arrList[index].url = 'PianMa'
  //                 break;
  //               case '前域':
  //                 arrList[index].url = 'QianYu'
  //                 break;
  //               case '清溪':
  //                 arrList[index].url = 'QingXi'
  //                 break;
  //               case '晒经':
  //                 arrList[index].url = 'ShaiJin'
  //                 break;
  //               case '顺河':
  //                 arrList[index].url = 'ShunHe'
  //                 break;
  //               case '唐家':
  //                 arrList[index].url = 'TangJia'
  //                 break;
  //               case '乌斯':
  //                 arrList[index].url = 'WuSiHe'
  //                 break;
  //               case '小堡':
  //                 arrList[index].url = 'XiaoBao'
  //                 break;
  //               case '富泉':
  //                 arrList[index].url = 'FuQuan'
  //                 break;
  //               case '宜东':
  //                 arrList[index].url = 'YiDong'
  //                 break;
  //               case '永利':
  //                 arrList[index].url = 'YongLi'
  //                 break;
  //               default:
  //                 break;
  //             }
  //           }
  //           // console.log(arrList,'结果')
  //           this.villages = arrList;
  //           let obj = this.villages.find(el => el.name == this.name);
  //           if (obj) {
  //             this.mapId = obj.mapId;
  //           }
  //         }
  //       } else {
  //         this.$message.error('获取乡镇列表失败！')
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.HanYuan {
  background: url('../../../../src/assets/img/HanYuan/HanYuanBj.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 30px;
}

.spring .top_title {
  color: #384890;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #384890;
  height: 12%;
}
.summer .top_title {
  color: #384890;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #384890;
  height: 12%;
}
.autumn .top_title {
  color: #384890;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #384890;
  height: 12%;
}
.winter .top_title {
  color: #384890;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #384890;
  height: 12%;
}
.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}
</style>